import "maplibre-gl/dist/maplibre-gl.css";
import { useEffect } from "react";
import { Route, Router, Switch } from "wouter";
import { useHashLocation } from "wouter/use-hash-location";
import "./App.css";
import { sync } from "./db.sync";
import { Home } from "./routes/Home";
import { Nearby } from "./routes/Nearby";
import { Collect } from "./routes/Collect";
import { Artwork } from "./routes/Artwork";

function App() {
  useEffect(() => void sync(), []);

  return (
    <Router hook={useHashLocation}>
      <Switch>
        <Route path="/">
          <Home />
        </Route>

        <Route path="/nearby">
          <Nearby />
        </Route>

        <Route path="/collect/:id">
          <Collect />
        </Route>

        <Route path="/art/:id">
          <Artwork />
        </Route>

        <Route path="/debug-error">
          <button
            onClick={() => {
              throw new Error("This is your first error!");
            }}
          >
            Throw Error
          </button>
        </Route>

        <Route>
          <h2>Page not found</h2>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
